import React from 'react';
import Field from 'redux-form/lib/Field';
import formValueSelector from 'redux-form/lib/formValueSelector';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';


import SelectFieldComponent from '../../Common/FormField/SelectFieldComponent';
import InputFieldComponent from '../../Common/FormField/InputFieldComponent';
import messages from '../../../locale/messages';
import bt from '../../../components/commonStyle.css';
import s from './SiteConfigForm.css';

function Recaptcha() {
  const { formatMessage } = useIntl();

  const selector = formValueSelector('SiteConfigForm');
  const selectedVersion = useSelector((state) => selector(state, 'reCaptchaStatus'));

  const version = selectedVersion || 'v2';

  return (
    <div>
      <p className={s.siteAdminSubHeading}>{formatMessage(messages.reCaptchaLabel)}</p>
      <div className={s.siteConfigSubGridContainer}>
        <Field
          name="reCaptchaStatus"
          type="text"
          component={SelectFieldComponent}
          label={formatMessage(messages.reCaptchaVersion)}
          inputClass={cx(bt.commonControlSelect, 'commonControlSelectRtl')}
          formGroupClass={bt.space4}
          options={[
            { value: "v2", label: formatMessage(messages.v2) },
            { value: "v3", label: formatMessage(messages.v3) }
          ]}
          infoText={formatMessage(messages.reCaptchaVersionToolTip)}
          showToolTip
        />
        {version === 'v2' && (
          <div className={cx(s.girdOne, s.siteConfigSubGridItem)}>
            <Field
              name="v2Sitekey"
              type="text"
              component={InputFieldComponent}
              label={formatMessage(messages.reCaptchaSiteKey)}
              inputClass={bt.commonControlInput}
              formGroupClass={bt.space4}
              infoText={formatMessage(messages.reCaptchaSiteKeyToolTip)}
              showToolTip
              placeholder={formatMessage(messages.reCaptchaSiteKeyPlaceHolder)}
            />
            <Field
              name="reCaptchaV2"
              type="text"
              component={InputFieldComponent}
              label={formatMessage(messages.reCaptchaSecretKey)}
              inputClass={bt.commonControlInput}
              formGroupClass={bt.space4}
              infoText={formatMessage(messages.reCaptchaSecretKeyToolTip)}
              showToolTip
              placeholder={formatMessage(messages.reCaptchaSecretKeyPlaceHolder)}
            />
          </div>
        )}

        {version === 'v3' && (
          <div className={cx(s.girdOne, s.siteConfigSubGridItem)}>
            <Field
              name="v3Sitekey"
              type="text"
              component={InputFieldComponent}
              label={formatMessage(messages.reCaptchaSiteKey)}
              inputClass={bt.commonControlInput}
              formGroupClass={bt.space4}
              infoText={formatMessage(messages.reCaptchaSiteKeyToolTip)}
              showToolTip
              placeholder={formatMessage(messages.reCaptchaSiteKeyPlaceHolder)}
            />
            <Field
              name="reCaptchaV3"
              type="text"
              component={InputFieldComponent}
              label={formatMessage(messages.reCaptchaSecretKey)}
              inputClass={bt.commonControlInput}
              formGroupClass={bt.space4}
              infoText={formatMessage(messages.reCaptchaSecretKeyToolTip)}
              showToolTip
              placeholder={formatMessage(messages.reCaptchaSecretKeyPlaceHolder)}
            />
          </div>
        )}


      </div>
    </div>
  );
}

export default withStyles(s, bt)(Recaptcha);
